import { createContext } from "react";
import { LayerInfo } from "../../../types/LayerAdmin/LayerInfo";
import LayerAdminService from "../../../services/LayerAdminService";

export interface LayerContextType {
  layerInfo: LayerInfo;
  setLayerInfo: (layerInfo: LayerInfo) => void;
  setImportPage: (page: number) => void;
  layerAdminService: LayerAdminService;
  importsLoading: boolean;
  refreshLayerInfo: () => void;
}

export const LayerContext = createContext<LayerContextType | null>(null);